export default [
  {
    path: '',
    name: 'settings-technical',
    component: () => import(/* webpackChunkName: "settings-technical" */ '~/views/Settings/SettingsTechnicalWork/SettingsTechnicalWork.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderSettings' },
    },
  },



  {
    path: 'email',
    name: 'settings-email',
    component: () => import(/* webpackChunkName: "settings-email" */ '~/views/Settings/SettingsEmail/SettingsEmail.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderSettings' },
      rootRouteName: 'settings-technical',
    },
  },

  {
    path: 'watermark',
    name: 'settings-watermark',
    component: () => import(/* webpackChunkName: "settings-watermark" */ '~/views/Settings/SettingsWatermark/SettingsWatermark.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderSettings' },
      rootRouteName: 'settings-technical',
    },
  },

  {
    path: 'aml-kyt',
    name: 'settings-amlKyt',
    component: () => import(/* webpackChunkName: "settings-amlKyt" */ '~/views/Settings/SettingsAMLKYT/SettingsAMLKYT.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderSettings' },
      rootRouteName: 'settings-amlKyt',
    },
  },
];
